module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Control numbers","apr":"APR","totalCost":"Total credit cost"},"et":{"title":"Control numbers","apr":"APR","totalCost":"Total credit cost"},"ru":{"title":"Control numbers","apr":"APR","totalCost":"Total credit cost"}}')
  delete Component.options._Ctor
}
